document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-add-bundle').forEach(button => {
    if (button.dataset.bundleInit === 'true') return;
    button.dataset.bundleInit = 'true';

    button.addEventListener('click', function (e) {
      e.preventDefault();

      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      this.disabled = true;
      this.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
      // console.log("FIXING QTY TO 1 ")
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => fetch(window.Shopify.routes.root + '?section_id=cart-drawer'))
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        if (!newDrawer) return;

        const currentDrawer = document.querySelector('cart-drawer');
        currentDrawer.replaceWith(newDrawer);
        requestAnimationFrame(() => {
          newDrawer.open();
          button.disabled = false;
          button.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
        });
      })
      .catch(err => {
        console.error(err);
        this.disabled = false;
        this.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
      });
    });
  });
});
